import axios, { AxiosResponse } from 'axios';

const api = axios.create({
  baseURL: 'https://api.github.com',
  headers: {
    Accept: 'application/vnd.github.v3+json',
  },
});

export const getMembers = async (): Promise<IMemberGithub[]> => {
  try {
    const response: AxiosResponse = await api.get('/orgs/devserido/members');
    return response.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getMeetups = async (): Promise<IRepoGithub[]> => {
  try {
    const response: AxiosResponse<IRepoGithub[]> = await api.get(
      '/orgs/devserido/repos',
    );
    const meetups = response.data.filter(repo =>
      repo.topics.includes('meetup'),
    );

    return meetups;
  } catch (error) {
    console.log(error);
    return [];
  }
};
